import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";

import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import { useParams } from "react-router-dom";



function FacturasTiendasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_SERIES_FISCAL = import.meta.env.VITE_URL_SERIES_FISCAL;
  const URL_TIMBRAR = import.meta.env.VITE_URL_TIMBRAR;
  const URL_FACTURAS = import.meta.env.VITE_URL_FACTURAS;
  const URL_ARTICULOS_VENTAS_TIENDAS = import.meta.env.VITE_URL_ARTICULOS_VENTAS_TIENDAS;
  const URL_VENTAS_TIENDAS = import.meta.env.VITE_URL_VENTAS_TIENDAS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_EMPRESAS = import.meta.env.VITE_URL_EMPRESAS;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
    const URL_TALLAS = import.meta.env.VITE_URL_TALLAS;


  const { idVenta } = useParams();

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");

  const [tallas, setTallas] = useState([]);
  const [customSizeOrder, setCustomSizeOrder] = useState([]);

  const [timbresDisponibles, setTimbresDisponibles] = useState(0);

  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalCant, setTotalCant] = useState(0);

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");

  const [condicionesPagoSATCliente, setCondicionesPagoSATCliente] = useState("Contado");
  const [formaPagoSATCliente, setFormaPagoSATCliente] = useState("04");
  const [metodoPagoSATCliente, setMetodoPagoSATCliente] = useState("PUE");
  const [rfcCliente, setRfcCliente] = useState("");
  const [nombreCliente, setNombreCliente] = useState("");
  const [usoCFDICliente, setUsoCFDICliente] = useState("");
  const [regFiscalCliente, setRegFiscalCliente] = useState("");
  const [cpCliente, setCpCliente] = useState("");

  const [serie, setSerie] = useState("A");


  const [inputFields, setInputFields] = useState([]);

  const [surtidosData, setSurtidosData] = useState([]);
  const [tallasColumns, setTallasColumns] = useState([]);


  const [validaBoton, setValidaBoton] = useState(true);

  const [facturarPublicoGeneral, setFacturarPublicoGeneral] = useState(false);
  const [datosClientePrevios, setDatosClientePrevios] = useState({});

  // Helper function to extract and format error messages from API responses
  const getErrorMessage = (error) => {
    let errorMessage = "Error desconocido";
    let errorDetails = "";

    try {
      // Check if it's a Facturama API error (400 Bad Request)
      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 && data) {
          // Facturama API error format - check for common Facturama error structures
          if (typeof data === 'string') {
            errorMessage = "Error de Facturama";
            errorDetails = data;
          } else if (data.ModelState) {
            // Facturama validation errors format
            errorMessage = "Error de validación de Facturama";
            const validationErrors = [];
            const fieldTranslations = {
              'cfdiToCreate.Receiver.Rfc': 'RFC del receptor',
              'cfdiToCreate.Receiver.FiscalRegime': 'Régimen fiscal del receptor',
              'cfdiToCreate.Receiver.Name': 'Nombre del receptor',
              'cfdiToCreate.Receiver.TaxZipCode': 'Código postal del receptor',
              'cfdiToCreate.Issuer.Rfc': 'RFC del emisor',
              'cfdiToCreate.Issuer.FiscalRegime': 'Régimen fiscal del emisor',
              'cfdiToCreate.Issuer.Name': 'Nombre del emisor',
              'cfdiToCreate.PaymentConditions': 'Condiciones de pago',
              'cfdiToCreate.PaymentForm': 'Forma de pago',
              'cfdiToCreate.PaymentMethod': 'Método de pago',
              'cfdiToCreate.CfdiUse': 'Uso de CFDI',
              'cfdiToCreate.Items': 'Artículos de la factura'
            };

            Object.keys(data.ModelState).forEach(key => {
              if (Array.isArray(data.ModelState[key])) {
                const fieldName = fieldTranslations[key] || key;
                data.ModelState[key].forEach(errorMsg => {
                  validationErrors.push(`${fieldName}: ${errorMsg}`);
                });
              }
            });

            // Add main message if available
            if (data.Message) {
              errorDetails = `${data.Message}\n\nDetalles:\n• ${validationErrors.join('\n• ')}`;
            } else {
              errorDetails = `Errores de validación:\n• ${validationErrors.join('\n• ')}`;
            }
          } else if (data.Message) {
            // Facturama standard error format
            errorMessage = "Error de Facturama";
            errorDetails = data.Message;
          } else if (data.message) {
            errorMessage = "Error de Facturama";
            errorDetails = data.message;
          } else if (data.error) {
            errorMessage = "Error de Facturama";
            errorDetails = data.error;
          } else if (data.errors && Array.isArray(data.errors)) {
            errorMessage = "Error de Facturama";
            errorDetails = data.errors.map(err => err.message || err.Message || err).join(', ');
          } else if (data.ExceptionMessage) {
            // Facturama exception format
            errorMessage = "Error de Facturama";
            errorDetails = data.ExceptionMessage;
          } else {
            errorMessage = "Error de Facturama";
            errorDetails = JSON.stringify(data);
          }
        } else if (data && data.message) {
          errorMessage = "Error del servidor";
          errorDetails = data.message;
        } else {
          errorMessage = `Error ${status}`;
          errorDetails = data ? JSON.stringify(data) : "Sin detalles adicionales";
        }
      } else if (error.message) {
        errorMessage = "Error de conexión";
        errorDetails = error.message;
      }
    } catch (parseError) {
      errorMessage = "Error al procesar la respuesta";
      errorDetails = error.toString();
    }

    return { errorMessage, errorDetails };
  };

  // Build pivoted data (Articulo + Color rows with Talla columns) from nota items,
  // matching the Traspasos PDF layout
  const buildSurtidosFromNotaItems = (items = []) => {
    // Unique tallas present sorted by custom size order
    const allTallas = Array.from(
      new Set(items.map((a) => a?.tallas?.[0]?.name).filter(Boolean))
    ).sort((a, b) => {
      const ia = customSizeOrder.indexOf(a);
      const ib = customSizeOrder.indexOf(b);
      return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
    });
    setTallasColumns(allTallas);

    // Group by articulo codigo + color
    const groups = new Map();
    items.forEach((a) => {
      const codigo = a?.articulos?.[0]?.codigo || a?.articulos?.[0]?.nombre || "";
      const color = a?.colores?.[0]?.name || "";
      const talla = a?.tallas?.[0]?.name || "";
      const precio = Number(a?.precio) || 0;
      const cantidad = Number(a?.cantidad) || 0;
      const key = `${codigo}|||${color}`;
      if (!groups.has(key)) {
        const baseQtys = {};
        allTallas.forEach((t) => (baseQtys[t] = 0));
        groups.set(key, { articulo: codigo, color, precio, qtys: baseQtys });
      }
      const row = groups.get(key);
      row.qtys[talla] = (row.qtys[talla] || 0) + cantidad;
      // Keep the first seen price per articulo+color
      if (!row.precio) row.precio = precio;
    });

    const rows = Array.from(groups.values()).sort((a, b) =>
      a.articulo === b.articulo
        ? (a.color || "").localeCompare(b.color || "")
        : (a.articulo || "").localeCompare(b.articulo || "")
    );

    setSurtidosData(rows);
  };

  const fetchNotaDetalleAndSet = async (notaId) => {
    const response = await axios.get(
      `${URL_ARTICULOS_VENTAS_TIENDAS}/ventasTiendas/${notaId}`,
      {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      }
    );
    buildSurtidosFromNotaItems(response.data || []);
  };

  // Modal para editar datos de facturación (facturar a otro nombre)
  const [modalCustomFactura, setModalCustomFactura] = useState(false);
  const toggleCustomFactura = () => setModalCustomFactura(!modalCustomFactura);

  useEffect(() => {
    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SERIES_FISCAL}Timbres`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTimbres = res.data;
        setTimbresDisponibles(allTimbres[0].folio);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_EMPRESAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmpresas = res.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${URL_COLABORADORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    if (idVenta && clientes.length > 0) {
      axios
        .get(`${URL_VENTAS_TIENDAS}/${idVenta}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then(async (res) => {
          const venta = res.data;
          setSelectedCliente(venta.clientes[0]._id);
          BuscaCliente(venta.clientes[0]._id);
          BuscaSurtido(idVenta);

          // Setear InputFields
          let arrayVenta = [
            {
              id: uuidv4(),
              surtidos: venta._id,
              idSurtido: venta.prefijo + " " + venta.consecutivo,
              total: venta.subTotal,
              totalCantidad: Number(venta.total_cantidad),
            },
          ];

          setInputFields(arrayVenta);

          // ActualizaTotales;

          let din = arrayVenta.map((c) => parseFloat(c.total));
          let TD = din.reduce((t, total, index) => t + total, 0);
          setSubTotal(TD);

          let tcan = arrayVenta.map((c) => Number(c.totalCantidad)).filter(n => !isNaN(n));
          let TDCan = tcan.reduce((t, total, index) => t + total, 0);
          setTotalCant(TDCan);

          let iva = TD / 1.16;
          setIva(Number(iva.toFixed(2)));

          let total = TD;
          setTotal(total);
          // Jala Articulos

          await fetchNotaDetalleAndSet(idVenta);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [idVenta, clientes.length]);

  useEffect(() => {
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
        const customeSizeOrder = allTallas.map((t) => t.name);
        setCustomSizeOrder(customeSizeOrder);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  const saveFacturaNuevo = async (event) => {
    event.preventDefault();
    if (timbresDisponibles > 0) {
      Swal.fire({
        title: "Estas seguro?",
        text: "Se guardará la Factura!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, guardar!",
      }).then(async (result) => {
        if (result.isConfirmed && subTotal > 0 && total > 0) {
          // Validate totalCantidad before proceeding
          const validTotalCant = Number(totalCant);
          if (!validTotalCant || validTotalCant <= 0) {
            Swal.fire({
              icon: "error",
              title: "Error de validación",
              text: "No se puede crear una factura sin cantidad de productos válida. Verifique que haya seleccionado productos correctamente.",
              confirmButtonText: "Entendido"
            });
            setValidaBoton(true);
            setModalProgreso(false);
            return;
          }
          setValidaBoton(false);
          toggleProgreso();

          let totalArticulos = inputFields.length;

          // Debug payload before sending
          const payload = {
                  fecha,
                  observaciones,
                  totalCantidad: Number(totalCant),
                  subTotal: Number(subTotal ?? 0),
                  iva: Number(iva ?? 0),
                  total: Number(total ?? 0),
                  abonos: 0,
                  saldo: Number(total ?? 0),
                  pagado: "No",
                  descuentoPorcentaje1: 0,
                  descuentoNumero1: 0,
                  descuentoConcepto1: "NA",
                  descuentoPorcentaje2: 0,
                  descuentoNumero2: 0,
                  descuentoConcepto2: "NA",
                  empresas: selectedEmpresa,
                  clientes: selectedCliente,
                  colaboradores: selectedColaborador,
                  timbre: "No",
                  currency: "MXN",
                  cfdiType: "I",

                  serie,
                  expeditionPlace: cpEmpresa,

                  rfcEmpresa,
                  nombreEmpresa,
                  regFiscalEmpresa,

                  condicionesPagoSATCliente,
                  formaPagoSATCliente,
                  metodoPagoSATCliente,
                  rfcCliente,
                  nombreCliente,
                  usoCFDICliente,
                  regFiscalCliente,
                  cpCliente: cpCliente.toString(),

                  numeroPagos: 0,
          };

          console.log('Payload being sent:', payload);
          console.log('totalCantidad type:', typeof payload.totalCantidad, 'value:', payload.totalCantidad);

          try {
            await axios
              .post(
                URL_FACTURAS,
                payload,
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then((data) => {
                inputFields.map((w) => {
                  axios
                    .patch(
                      `${URL_VENTAS_TIENDAS}Factura/${w.surtidos}`,
                      {
                        facturas: data.data._id,
                        facturado: "Si",
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            "app_token"
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      totalArticulos = totalArticulos - 1;
                      if (totalArticulos == 0) {
                        axios
                          .post(
                            `${URL_TIMBRAR}FacturaVentaTienda`,
                            {
                              facturas: data.data._id,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then(() => {
                            axios
                              .post(
                                URL_LOGS,
                                {
                                  tipo: "Crear Factura",
                                  detalle: `Fecha Factura ${fecha} ${data.data.idFactura}`,
                                  user: user.id,
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer: ${localStorage.getItem(
                                      "app_token"
                                    )}`,
                                  },
                                }
                              )
                              .then(() => {
                                Swal.fire(
                                  "Good job!",
                                  "Creado con exito",
                                  "success"
                                );
                                setTimeout(() => {
                                  window.location.reload();
                                }, 1000);
                              })
                              .catch((error) => {
                                const { errorMessage, errorDetails } = getErrorMessage(error);
                                Swal.fire({
                                  icon: "error",
                                  title: errorMessage,
                                  text: "Error al crear el log de la factura",
                                  footer: errorDetails,
                                });
                                console.log(error);
                                setValidaBoton(true);
                                setModalProgreso(false);
                              });
                          })
                          .catch((error) => {
                            const { errorMessage, errorDetails } = getErrorMessage(error);
                            Swal.fire({
                              icon: "error",
                              title: errorMessage,
                              text: "Error al timbrar la factura con Facturama",
                              footer: errorDetails,
                            });
                            console.log(error);
                            setValidaBoton(true);
                            setModalProgreso(false);
                          });
                      }
                    })
                    .catch((error) => {
                      const { errorMessage, errorDetails } = getErrorMessage(error);
                      Swal.fire({
                        icon: "error",
                        title: errorMessage,
                        text: "Error al actualizar el estado de la venta",
                        footer: errorDetails,
                      });
                      console.log(error);
                      setValidaBoton(true);
                      setModalProgreso(false);
                    });
                });
              })
              // Catch primer then
              .catch((error) => {
                const { errorMessage, errorDetails } = getErrorMessage(error);
                Swal.fire({
                  icon: "error",
                  title: errorMessage,
                  text: "Error al crear la factura",
                  footer: errorDetails,
                });
                console.log(error);
                setValidaBoton(true);
                setModalProgreso(false);
              });
          } catch (error) {
            const { errorMessage, errorDetails } = getErrorMessage(error);
            Swal.fire({
              icon: "error",
              title: errorMessage,
              text: "Error inesperado al procesar la factura",
              footer: errorDetails,
            });
            console.log(error);
            setValidaBoton(true);
            setModalProgreso(false);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `Faltan Datos`,
          });
          setValidaBoton(true);
          setModalProgreso(false);
        }
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `No cuenta con timbres disponibles`,
      });
      setValidaBoton(true);
      setModalProgreso(false);
    }
  };

  function BuscaCliente(id) {
    setSelectedCliente(id);
    setSurtidosData([]);

    setInputFields([
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);

    clientes.map((a) => {
      if (a._id == id) {
        setSelectedColaborador(a.vendedor[0]._id);

        if (!facturarPublicoGeneral) {
          setCondicionesPagoSATCliente(a.condicionesPagoSAT);
          setRfcCliente(a.RFC);
          setNombreCliente(a.razon_social);
          setUsoCFDICliente(a.usoCFDI);
          setRegFiscalCliente(a.regFiscal);
          setCpCliente(a.cp);

          if (a.metodoPagoSAT != "PPD") {
            setFormaPagoSATCliente(a.formaPagoSAT);
            setMetodoPagoSATCliente(a.metodoPagoSAT);
          } else {
            setFormaPagoSATCliente("99");
            setMetodoPagoSATCliente(a.metodoPagoSAT);
          }
        }

        setDatosClientePrevios({
          condicionesPagoSATCliente: a.condicionesPagoSAT,
          formaPagoSATCliente: a.metodoPagoSAT !== "PPD" ? a.formaPagoSAT : "99",
          metodoPagoSATCliente: a.metodoPagoSAT,
          rfcCliente: a.RFC,
          nombreCliente: a.razon_social,
          usoCFDICliente: a.usoCFDI,
          regFiscalCliente: a.regFiscal,
          cpCliente: a.cp,
        });
      }
    });

    axios
      .get(`${URL_VENTAS_TIENDAS}Facturacion/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSurtidos = res.data;
        let arrayTabla = allSurtidos.map((a) => {
          return {
            id: uuidv4(),
            surtidos: a._id,
            idSurtido: a.prefijo + " " + a.consecutivo,
            total: a.subTotal,
            totalCantidad: Number(a.totalCantidad || a.total_cantidad),
          };
        });
        let dataFinal = Object.values(arrayTabla);
        setSurtidos(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value);

    empresas.map((a) => {
      if (a._id == event.target.value) {
        setCpEmpresa(a.cp);
        setRfcEmpresa(a.rfc);
        setNombreEmpresa(a.razonSocial);
        setRegFiscalEmpresa(a.regimenFiscal);
      }
    });
    setInputFields([
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);
    if (event.target.value != "" && selectedCliente != "") {
      axios
        .get(`${URL_VENTAS_TIENDAS}Facturacion/${selectedCliente}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSurtidos = res.data;
          let arrayTabla = allSurtidos.map((a) => {
            return {
              id: uuidv4(),
              surtidos: a._id,
              idSurtido: a.prefijo + " " + a.consecutivo,
              total: a.subTotal,
              totalCantidad: Number(a.totalCantidad || a.total_cantidad),
            };
          });
          let dataFinal = Object.values(arrayTabla);
          setSurtidos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async function BuscaSurtido(id, event) {
    setSurtidosData([]);

    if (inputFields.some((e) => e.surtidos === event.target.value)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido ya fue capturado!",
        showConfirmButton: false,
      });

      setInputFields(
        inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i))
      );
      return;
    }

    try {
      surtidos.map((a) => {
        if (a.surtidos == event.target.value) {
          let surtidos = a.surtidos;
          let idSurtido = a.idSurtido;
          let total = a.total;
          let totalCantidad = a.totalCantidad;
          handleChangeInputArticulo(
            id,
            surtidos,
            idSurtido,
            total,
            totalCantidad
          );
        }
      });

      await fetchNotaDetalleAndSet(event.target.value);
    } catch (err) {
      console.error("Error en la petición a la API:", err);
    }
  }

  const handleChangeInputArticulo = (
    id,
    surtidos,
    idSurtido,
    total,
    totalCantidad
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.surtidos = surtidos;
        i.idSurtido = idSurtido;
        i.total = total;
        i.totalCantidad = totalCantidad;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let din = inputFields.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setSubTotal(TD);

    let tcan = inputFields.map((c) => Number(c.totalCantidad)).filter(n => !isNaN(n));
    let TDCan = tcan.reduce((t, total, index) => t + total, 0);
    setTotalCant(TDCan);

    let iva = TD / 1.16;
    setIva(Number(iva.toFixed(2)));

    let total = TD;
    setTotal(total);
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ventasTiendas ? (
        <div className="card container col-11">
          <h3 align="center">Nueva Factura</h3>
          <Form onSubmit={saveFacturaNuevo}>
            <Row>
              <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Factura</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                <Input
                  style={{ backgroundColor: "yellow" }}
                  name="empresa"
                  type="select"
                  value={selectedEmpresa}
                  required
                  onChange={(event) => {
                    BuscaEmpresa(event);
                  }}
                >
                  <option value="">Selecciona</option>
                  {empresas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.listoFacturar == "Si" && a.is_active == "Si") {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Serie</Label>
                <Input
                  style={{ backgroundColor: "yellow" }}
                  type="select"
                  value={serie}
                  required
                  onChange={(event) => {
                    setSerie(event.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="A">A</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={2} className="mt-4">
                <Button
                  color={facturarPublicoGeneral ? "danger" : "primary"}
                  onClick={() => {
                    const nuevoEstado = !facturarPublicoGeneral;
                    setFacturarPublicoGeneral(nuevoEstado);

                    if (nuevoEstado) {
                      // Activar público general
                      setCondicionesPagoSATCliente("Contado");
                      setFormaPagoSATCliente("04");
                      setMetodoPagoSATCliente("PUE");
                      setRfcCliente("XAXX010101000");
                      setNombreCliente("Público en general");
                      setUsoCFDICliente("S01");
                      setRegFiscalCliente("616");
                      setCpCliente("06000");
                    } else {
                      // Restaurar cliente previo si existe
                      if (datosClientePrevios.rfcCliente) {
                        setCondicionesPagoSATCliente(datosClientePrevios.condicionesPagoSATCliente);
                        setFormaPagoSATCliente( datosClientePrevios.formaPagoSATCliente );
                        setMetodoPagoSATCliente( datosClientePrevios.metodoPagoSATCliente);
                        setRfcCliente(datosClientePrevios.rfcCliente);
                        setNombreCliente(datosClientePrevios.nombreCliente);
                        setUsoCFDICliente(datosClientePrevios.usoCFDICliente);
                        setRegFiscalCliente(datosClientePrevios.regFiscalCliente);
                        setCpCliente(datosClientePrevios.cpCliente);
                      }
                    }
                  }}
                >
                  {facturarPublicoGeneral
                    ? "❌ Quitar Público General"
                    : "✔ Facturar a Público General"}
                </Button>
              </Col>

              <Col md={2}>
                <Label>Cliente</Label>
                <Input
                  type="select"
                  value={selectedCliente}
                  required
                  onChange={(event) => {
                    BuscaCliente(event.target.value);
                  }}
                >
                  <option value="">Selecciona un Cliente</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>
                          {a.razon_social} / {a.nombre_comercial}
                        </option>
                      );
                    })}
                </Input>
              </Col>

              <Col md={2} className="mt-4">
                <Button color="info" onClick={() => setModalCustomFactura(true)}>
                  Facturar a otro Nombre
                </Button>
              </Col>


              {/* <Col md={2}>
                <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      required
                      onChange={(event) => {
                        BuscaColaborador(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre} {a.apellido} </option>
                          );
                      })}
                    </Input>
                  </Col> */}

              <Col md={2}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  style={{ backgroundColor: "yellow" }}
                  type="select"
                  value={formaPagoSATCliente}
                  required
                  onChange={(e) => {
                    setFormaPagoSATCliente(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="01"> 01 Efectivo</option>
                  <option value="02"> 02 Cheque nominativo</option>
                  <option value="03"> 03 Transferencia electrónica de fondos</option>
                  <option value="04"> 04 Tarjeta de crédito</option>
                  <option value="05"> 05 Monedero electrónico</option>
                  <option value="06"> 06 Dinero electrónico</option>
                  <option value="08"> 08 Vales de despensa</option>
                  <option value="12"> 12 Dación en pago</option>
                  <option value="13"> 13 Pago por subrogación</option>
                  <option value="14"> 14 Pago por consignación</option>
                  <option value="15"> 15 Condonación</option>
                  <option value="17"> 17 Compensación</option>
                  <option value="23"> 23 Novación</option>
                  <option value="24"> 24 Confusión</option>
                  <option value="25"> 25 Remisión de deuda</option>
                  <option value="26"> 26 Prescripción o caducidad</option>
                  <option value="27"> 27 A satisfacción del acreedor</option>
                  <option value="28"> 28 Tarjeta de débito</option>
                  <option value="29"> 29 Tarjeta de servicios</option>
                  <option value="30"> 30 Aplicación de anticipos</option>
                  <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={2}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSATCliente}
                  required
                  onChange={(e) => {
                    setMetodoPagoSATCliente(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
                  <option value="PPD">
                    PPD (Pago en Parcialidades o Diferido)
                  </option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Autorizacion TDC (4 Digitos)
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Nota</Label>
              </Col>
            </Row>
            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      name="surtidos"
                      type="select"
                      value={inputField.surtidos}
                      required
                      onChange={(event) => {
                        BuscaSurtido(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {surtidos
                        .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a.surtidos}>
                              Venta: {a.idSurtido} /{" "}
                              {new Intl.NumberFormat("es-MX", {
                                style: "currency",
                                currency: "MXN",
                              }).format(a.total)}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  {/* <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i className="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ))}

            {/* Tabla Articulos */}
            {surtidosData.length > 0 && (
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12">
                    <table className="table table-striped table-bordered align-middle table-sm">
                      <thead>
                        <tr>
                          <th>Articulo</th>
                          <th>Color</th>
                          {tallasColumns.map((t, index) => (
                            <th key={index} className="text-center">{t}</th>
                          ))}
                          <th className="text-center">Total Piezas</th>
                          <th className="text-end">Precio</th>
                          <th className="text-end">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {surtidosData.map((row, index) => {
                          const totalPiezas = tallasColumns.reduce(
                            (sum, t) => sum + (row.qtys?.[t] || 0),
                            0
                          );
                          return (
                            <tr key={index}>
                              <td>{row.nombreArticulo || row.articulo}</td>
                              <td>{row.color}</td>
                              {tallasColumns.map((t, i) => (
                                <td key={i} className="text-center">{row.qtys?.[t] || 0}</td>
                              ))}
                              <td className="text-center"><strong>{totalPiezas}</strong></td>
                              <td className="text-end">{new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(row.precio || 0)}</td>
                              <td className="text-end"><strong>{new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(totalPiezas * (row.precio || 0))}</strong></td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td className="text-end"><strong>Total</strong></td>
                          {tallasColumns.map((t, i) => {
                            const totalColumna = surtidosData.reduce(
                              (sum, row) => sum + (row.qtys?.[t] || 0),
                              0
                            );
                            return (
                              <td key={i} className="text-center"><strong>{totalColumna}</strong></td>
                            );
                          })}
                          <td className="text-center">
                            <strong>
                              {surtidosData.reduce(
                                (sum, row) => sum + tallasColumns.reduce((s, t) => s + (row.qtys?.[t] || 0), 0),
                                0
                              )}
                            </strong>
                          </td>
                          <td className="text-end"></td>
                          <td className="text-end">
                            <strong>
                              {new Intl.NumberFormat("es-MX", {
                                style: "currency",
                                currency: "MXN",
                              }).format(
                                surtidosData.reduce((sum, row) => {
                                  const piezas = tallasColumns.reduce((s, t) => s + (row.qtys?.[t] || 0), 0);
                                  return sum + piezas * (row.precio || 0);
                                }, 0)
                              )}
                            </strong>
                          </td>
                        </tr>
                      </tfoot>

                    </table>
                  </div>
                </div>
              </div>
            )}

            <br />
            <br />
            <Row>
              <Col>
                <Label className="mr-sm-2">Total Cantidad</Label>
                <Input
                  type="number"
                  value={totalCant}
                  disabled
                  style={{
                    backgroundColor: (!totalCant || totalCant <= 0) ? '#ffebee' : '',
                    borderColor: (!totalCant || totalCant <= 0) ? '#f44336' : ''
                  }}
                />
                {(!totalCant || totalCant <= 0) && (
                  <small className="text-danger">
                    Debe seleccionar productos válidos
                  </small>
                )}
              </Col>
              <Col>
                <Label className="mr-sm-2">Subtotal</Label>
                <Input type="number" value={subTotal} disabled />
              </Col>
              <Col>
                <Label className="mr-sm-2">IVA</Label>
                <Input type="number" value={iva} disabled />
              </Col>
              <Col>
                <Label className="mr-sm-2">Total</Label>
                <Input type="number" value={total} disabled />
              </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/MenuTiendas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.

              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>

          {/* Modal: Facturar a otro nombre */}
          <Modal isOpen={modalCustomFactura} toggle={toggleCustomFactura}>
            <ModalHeader toggle={toggleCustomFactura}>
              <h4>Datos de Facturación</h4>
            </ModalHeader>
            <ModalBody>
              <Form>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Nombre/Razón Social</Label>
                      <Input
                        type="text"
                        value={nombreCliente}
                        onChange={(e) => setNombreCliente(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>RFC</Label>
                      <Input
                        type="text"
                        value={rfcCliente}
                        onChange={(e) => setRfcCliente(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Condiciones de Pago</Label>
                      <Input
                        type="text"
                        value={condicionesPagoSATCliente}
                        onChange={(e) =>
                          setCondicionesPagoSATCliente(e.target.value)
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Código Postal</Label>
                      <Input
                        type="text"
                        value={cpCliente}
                        onChange={(e) => setCpCliente(e.target.value)}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Forma de Pago</Label>
                      <Input
                        type="select"
                        value={formaPagoSATCliente}
                        onChange={(e) => setFormaPagoSATCliente(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        <option value="01"> 01 Efectivo</option>
                        <option value="02"> 02 Cheque nominativo</option>
                        <option value="03">
                          {" "}
                          03 Transferencia electrónica de fondos
                        </option>
                        <option value="04"> 04 Tarjeta de crédito</option>
                        <option value="05"> 05 Monedero electrónico</option>
                        <option value="06"> 06 Dinero electrónico</option>
                        <option value="08"> 08 Vales de despensa</option>
                        <option value="12"> 12 Dación en pago</option>
                        <option value="13"> 13 Pago por subrogación</option>
                        <option value="14"> 14 Pago por consignación</option>
                        <option value="15"> 15 Condonación</option>
                        <option value="17"> 17 Compensación</option>
                        <option value="23"> 23 Novación</option>
                        <option value="24"> 24 Confusión</option>
                        <option value="25"> 25 Remisión de deuda</option>
                        <option value="26"> 26 Prescripción o caducidad</option>
                        <option value="27"> 27 A satisfacción del acreedor</option>
                        <option value="28"> 28 Tarjeta de débito</option>
                        <option value="29"> 29 Tarjeta de servicios</option>
                        <option value="30"> 30 Aplicación de anticipos</option>
                        <option value="99"> 99 Por definir</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Método de Pago</Label>
                      <Input
                        type="select"
                        value={metodoPagoSATCliente}
                        onChange={(e) => setMetodoPagoSATCliente(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        <option value="PUE">
                          PUE (Pago de Una Sola Exhibición)
                        </option>
                        <option value="PPD">
                          PPD (Pago en Parcialidades o Diferido)
                        </option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Uso de CFDI</Label>
                      <Input
                        type="select"
                        value={usoCFDICliente}
                        onChange={(e) => setUsoCFDICliente(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        <option value="G01">G01 - Adquisición de mercancías</option>
                        <option value="G02">
                          G02 - Devoluciones, descuentos o bonificaciones
                        </option>
                        <option value="G03">G03 - Gastos en general</option>
                        <option value="I01">I01 - Construcciones</option>
                        <option value="I02">
                          I02 - Mobiliario y equipo de oficina
                        </option>
                        <option value="I03">I03 - Equipo de transporte</option>
                        <option value="I04">I04 - Equipo de cómputo</option>
                        <option value="I05">
                          I05 - Dados, troqueles, moldes, matrices y herramental
                        </option>
                        <option value="I06">
                          I06 - Comunicaciones telefónicas
                        </option>
                        <option value="I07">
                          I07 - Comunicaciones satelitales
                        </option>
                        <option value="I08">I08 - Otra maquinaria y equipo</option>
                        <option value="D01">
                          D01 - Honorarios médicos, dentales y gastos hospitalarios
                        </option>
                        <option value="D02">
                          D02 - Gastos médicos por incapacidad o discapacidad
                        </option>
                        <option value="D03">D03 - Gastos funerales</option>
                        <option value="D04">D04 - Donativos</option>
                        <option value="D05">
                          D05 - Intereses reales efectivamente pagados por créditos
                          hipotecarios
                        </option>
                        <option value="D06">
                          D06 - Aportaciones voluntarias al SAR
                        </option>
                        <option value="D07">
                          D07 - Primas por seguros de gastos médicos
                        </option>
                        <option value="D08">
                          D08 - Gastos de transportación escolar obligatoria
                        </option>
                        <option value="D09">
                          D09 - Depósitos en cuentas para el ahorro
                        </option>
                        <option value="D10">
                          D10 - Pagos por servicios educativos
                        </option>
                        <option value="P01">P01 - Por definir</option>
                        <option value="S01">S01 - Sin efectos fiscales</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>Régimen Fiscal</Label>
                      <Input
                        type="select"
                        value={regFiscalCliente}
                        onChange={(e) => setRegFiscalCliente(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        <option value="601">
                          601 - General de Ley Personas Morales
                        </option>
                        <option value="603">
                          603 - Personas Morales con Fines no Lucrativos
                        </option>
                        <option value="605">
                          605 - Sueldos y Salarios e Ingresos Asimilados a Salarios
                        </option>
                        <option value="606">606 - Arrendamiento</option>
                        <option value="607">
                          607 - Régimen de Enajenación o Adquisición de Bienes
                        </option>
                        <option value="608">608 - Demás ingresos</option>
                        <option value="609">609 - Consolidación</option>
                        <option value="610">
                          610 - Residentes en el Extranjero sin Establecimiento
                          Permanente en México
                        </option>
                        <option value="611">
                          611 - Ingresos por Dividendos (socios y accionistas)
                        </option>
                        <option value="612">
                          612 - Personas Físicas con Actividades Empresariales y
                          Profesionales
                        </option>
                        <option value="614">614 - Ingresos por intereses</option>
                        <option value="616">616 - Sin obligaciones fiscales</option>
                        <option value="620">
                          620 - Sociedades Cooperativas de Producción que optan por
                          diferir sus ingresos
                        </option>
                        <option value="621">621 - Incorporación Fiscal</option>
                        <option value="622">
                          622 - Actividades Agrícolas, Ganaderas, Silvícolas y
                          Pesqueras
                        </option>
                        <option value="623">
                          623 - Opcional para Grupos de Sociedades
                        </option>
                        <option value="624">624 - Coordinados</option>
                        <option value="625">
                          625 - Régimen de las Actividades Empresariales con
                          ingresos a través de Plataformas Tecnológicas
                        </option>
                        <option value="626">
                          626 - Régimen Simplificado de Confianza
                        </option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={() => {
                  // Update datosClientePrevios to store the current values
                  setDatosClientePrevios({
                    condicionesPagoSATCliente,
                    formaPagoSATCliente,
                    metodoPagoSATCliente,
                    rfcCliente,
                    nombreCliente,
                    usoCFDICliente,
                    regFiscalCliente,
                    cpCliente,
                  });
                  toggleCustomFactura();
                }}
              >
                Guardar
              </Button>
              <Button color="secondary" onClick={toggleCustomFactura}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>

        </div>
      ) : undefined}
    </>
  );
}

export default FacturasTiendasCreate;

